var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF4B55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12094_27968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0993 10.0015L13.1618 7.93909C13.3896 7.71121 13.3896 7.34177 13.1618 7.11425L12.8868 6.8393C12.6589 6.61136 12.2894 6.61136 12.0619 6.8393L9.99956 8.90165L7.93714 6.83888C7.70926 6.611 7.33982 6.611 7.1123 6.83888L6.83692 7.11382C6.60905 7.34177 6.60905 7.71121 6.83692 7.93873L8.8997 10.0015L6.83735 12.0639C6.6094 12.2918 6.6094 12.6612 6.83735 12.8888L7.1123 13.1637C7.34017 13.3916 7.70962 13.3916 7.93714 13.1637L9.99956 11.1013L12.0619 13.1637C12.2899 13.3916 12.6593 13.3916 12.8868 13.1637L13.1618 12.8888C13.3896 12.6608 13.3896 12.2914 13.1618 12.0639L11.0993 10.0015Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12094_27968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.66667,
    height: 6.66667,
    fill: "white",
    transform: "translate(6.66602 6.66797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle2);
export default __webpack_public_path__ + "static/media/close-circle-2.f65a4af2c134ca1a6e049b71badf7063.svg";
export { ForwardRef as ReactComponent };